import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/service/base.service';
import { Channel, ChannelEPGResponse, ChannelListResponse } from './channel.model';

@Injectable()
export class ChannelService {

  constructor(
    private http: HttpClient
  ) {
  }

  list(): Observable<ChannelListResponse> {
    const header = BaseService.basicHeader;
    return this.http.get<ChannelListResponse>(`${location.origin}/assets/json/channel-list.json`, { headers: header });
  }

  listProgram(slug: string): Observable<ChannelEPGResponse> {
    return this.http.get<ChannelEPGResponse>(`${location.origin}/assets/json/channel-epg-${slug}.json`);
  }
}
